import { TQuestion, TQuiz } from "../types/Aula";

export const initSatisfactionSurvey: TQuiz = {
    id: "",
    minimum_percentage_to_pass: 0,
    max_attempts: null,
    time_limit: null,
    name: "Encuesta de satisfacción",
    category: "survey",
    questions: [
        {
            id: "q_001",
            description: "¿Qué tan satisfecho/a estás respecto a la duración del curso?",
            order: 1,
            category: "satisfaction_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_002",
            description: "¿Qué tan satisfecho/a estás respecto a la plataforma en la que llevaste el curso?",
            order: 2,
            category: "satisfaction_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_003",
            description: "¿Qué tan satisfecho/a estás respecto al contenido o temario abarcado en el curso?",
            order: 3,
            category: "satisfaction_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_004",
            description: "¿Qué tan satisfecho/a estás respecto a los materiales proporcionados a lo largo del curso (vídeos, casos, imágenes, infografías, etc.)?",
            order: 4,
            category: "satisfaction_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_005",
            description: "¿Qué tan satisfecho/a estás respecto a las actividades del curso (vídeos interactivos, resolución de casos, evaluaciones, etc.)?",
            order: 5,
            category: "satisfaction_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_006",
            description: "¿Qué tan satisfecho/a estás respecto al nivel de complejidad de la evaluación final del curso?",
            order: 6,
            category: "satisfaction_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_007",
            description: "¿Consideras que el curso es útil para identificar las situaciones de hostigamiento o acoso sexual laboral?",
            order: 7,
            category: "utility_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_008",
            description: "En general, ¿cuál es tu grado de satisfacción respecto al curso?",
            order: 8,
            category: "satisfaction_level",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_009",
            description: "Considerando tu grado de satisfacción con la calidad del curso, ¿qué tan probable es que lo recomiendes a otras personas?",
            order: 9,
            category: "from_1_to_10",
            randomize_choices: false,
            choices: [],
        },
        {
            id: "q_010",
            description: "Puedes dejarnos tus comentarios aquí",
            category: "open_answer",
            order: 10,
            randomize_choices: false,
            choices: [],
        }
    ] as TQuestion[],
}